/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as DownloadsRouteImport } from './routes/downloads'
import { Route as HomeRouteImport } from './routes/home'
import { Route as JoinRouteImport } from './routes/join'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as ModdingRouteImport } from './routes/modding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminApiKeysRouteImport } from './routes/admin.api-keys'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminGamesRouteImport } from './routes/admin.games'
import { Route as AdminInsightsRouteImport } from './routes/admin.insights'
import { Route as AdminMembersRouteImport } from './routes/admin.members'
import { Route as AdminRolesRouteImport } from './routes/admin.roles'
import { Route as AdminStorageRouteImport } from './routes/admin.storage'
import { Route as AdminTeamRouteImport } from './routes/admin.team'
import { Route as AdminWebhooksRouteImport } from './routes/admin.webhooks'
import { Route as AuthHandoffRouteImport } from './routes/auth.handoff'
import { Route as GamesIndexRouteImport } from './routes/games.index'
import { Route as GamesSlugRouteImport } from './routes/games.$slug'
import { Route as AdminGamesIndexRouteImport } from './routes/admin.games.index'
import { Route as AdminGamesIdBuildsRouteImport } from './routes/admin.games.$id.builds'
import { Route as AdminGamesIdEditRouteImport } from './routes/admin.games.$id.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadsRoute = DownloadsRouteImport.update({
  id: '/downloads',
  path: '/downloads',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const ModdingRoute = ModdingRouteImport.update({
  id: '/modding',
  path: '/modding',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApiKeysRoute = AdminApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGamesRoute = AdminGamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInsightsRoute = AdminInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMembersRoute = AdminMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStorageRoute = AdminStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTeamRoute = AdminTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWebhooksRoute = AdminWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AdminRoute,
} as any)
const AuthHandoffRoute = AuthHandoffRouteImport.update({
  id: '/auth/handoff',
  path: '/auth/handoff',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesSlugRoute = GamesSlugRouteImport.update({
  id: '/games/$slug',
  path: '/games/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGamesIndexRoute = AdminGamesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminGamesRoute,
} as any)
const AdminGamesIdBuildsRoute = AdminGamesIdBuildsRouteImport.update({
  id: '/$id/builds',
  path: '/$id/builds',
  getParentRoute: () => AdminGamesRoute,
} as any)
const AdminGamesIdEditRoute = AdminGamesIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AdminGamesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRouteWithChildren
  '/download': typeof DownloadRoute
  '/downloads': typeof DownloadsRoute
  '/home': typeof HomeRoute
  '/join': typeof JoinRoute
  '/library': typeof LibraryRoute
  '/modding': typeof ModdingRoute
  '/notifications': typeof NotificationsRoute
  '/privacy': typeof PrivacyRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/games': typeof AdminGamesRouteWithChildren
  '/admin/insights': typeof AdminInsightsRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/storage': typeof AdminStorageRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/auth/handoff': typeof AuthHandoffRoute
  '/games/$slug': typeof GamesSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/games/': typeof GamesIndexRoute
  '/admin/games/': typeof AdminGamesIndexRoute
  '/admin/games/$id/builds': typeof AdminGamesIdBuildsRoute
  '/admin/games/$id/edit': typeof AdminGamesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/download': typeof DownloadRoute
  '/downloads': typeof DownloadsRoute
  '/home': typeof HomeRoute
  '/join': typeof JoinRoute
  '/library': typeof LibraryRoute
  '/modding': typeof ModdingRoute
  '/notifications': typeof NotificationsRoute
  '/privacy': typeof PrivacyRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/insights': typeof AdminInsightsRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/storage': typeof AdminStorageRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/auth/handoff': typeof AuthHandoffRoute
  '/games/$slug': typeof GamesSlugRoute
  '/admin': typeof AdminIndexRoute
  '/games': typeof GamesIndexRoute
  '/admin/games': typeof AdminGamesIndexRoute
  '/admin/games/$id/builds': typeof AdminGamesIdBuildsRoute
  '/admin/games/$id/edit': typeof AdminGamesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRouteWithChildren
  '/download': typeof DownloadRoute
  '/downloads': typeof DownloadsRoute
  '/home': typeof HomeRoute
  '/join': typeof JoinRoute
  '/library': typeof LibraryRoute
  '/modding': typeof ModdingRoute
  '/notifications': typeof NotificationsRoute
  '/privacy': typeof PrivacyRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/games': typeof AdminGamesRouteWithChildren
  '/admin/insights': typeof AdminInsightsRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/storage': typeof AdminStorageRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/auth/handoff': typeof AuthHandoffRoute
  '/games/$slug': typeof GamesSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/games/': typeof GamesIndexRoute
  '/admin/games/': typeof AdminGamesIndexRoute
  '/admin/games/$id/builds': typeof AdminGamesIdBuildsRoute
  '/admin/games/$id/edit': typeof AdminGamesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/admin'
    | '/download'
    | '/downloads'
    | '/home'
    | '/join'
    | '/library'
    | '/modding'
    | '/notifications'
    | '/privacy'
    | '/search'
    | '/settings'
    | '/signin'
    | '/studio'
    | '/terms'
    | '/admin/api-keys'
    | '/admin/audit'
    | '/admin/games'
    | '/admin/insights'
    | '/admin/members'
    | '/admin/roles'
    | '/admin/storage'
    | '/admin/team'
    | '/admin/webhooks'
    | '/auth/handoff'
    | '/games/$slug'
    | '/admin/'
    | '/games/'
    | '/admin/games/'
    | '/admin/games/$id/builds'
    | '/admin/games/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/download'
    | '/downloads'
    | '/home'
    | '/join'
    | '/library'
    | '/modding'
    | '/notifications'
    | '/privacy'
    | '/search'
    | '/settings'
    | '/signin'
    | '/studio'
    | '/terms'
    | '/admin/api-keys'
    | '/admin/audit'
    | '/admin/insights'
    | '/admin/members'
    | '/admin/roles'
    | '/admin/storage'
    | '/admin/team'
    | '/admin/webhooks'
    | '/auth/handoff'
    | '/games/$slug'
    | '/admin'
    | '/games'
    | '/admin/games'
    | '/admin/games/$id/builds'
    | '/admin/games/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/admin'
    | '/download'
    | '/downloads'
    | '/home'
    | '/join'
    | '/library'
    | '/modding'
    | '/notifications'
    | '/privacy'
    | '/search'
    | '/settings'
    | '/signin'
    | '/studio'
    | '/terms'
    | '/admin/api-keys'
    | '/admin/audit'
    | '/admin/games'
    | '/admin/insights'
    | '/admin/members'
    | '/admin/roles'
    | '/admin/storage'
    | '/admin/team'
    | '/admin/webhooks'
    | '/auth/handoff'
    | '/games/$slug'
    | '/admin/'
    | '/games/'
    | '/admin/games/'
    | '/admin/games/$id/builds'
    | '/admin/games/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  AdminRoute: typeof AdminRouteWithChildren
  DownloadRoute: typeof DownloadRoute
  DownloadsRoute: typeof DownloadsRoute
  HomeRoute: typeof HomeRoute
  JoinRoute: typeof JoinRoute
  LibraryRoute: typeof LibraryRoute
  ModdingRoute: typeof ModdingRoute
  NotificationsRoute: typeof NotificationsRoute
  PrivacyRoute: typeof PrivacyRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  SigninRoute: typeof SigninRoute
  StudioRoute: typeof StudioRoute
  TermsRoute: typeof TermsRoute
  AuthHandoffRoute: typeof AuthHandoffRoute
  GamesSlugRoute: typeof GamesSlugRoute
  GamesIndexRoute: typeof GamesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downloads': {
      id: '/downloads'
      path: '/downloads'
      fullPath: '/downloads'
      preLoaderRoute: typeof DownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/modding': {
      id: '/modding'
      path: '/modding'
      fullPath: '/modding'
      preLoaderRoute: typeof ModdingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/api-keys': {
      id: '/admin/api-keys'
      path: '/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AdminApiKeysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/games': {
      id: '/admin/games'
      path: '/games'
      fullPath: '/admin/games'
      preLoaderRoute: typeof AdminGamesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/insights': {
      id: '/admin/insights'
      path: '/insights'
      fullPath: '/admin/insights'
      preLoaderRoute: typeof AdminInsightsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/members': {
      id: '/admin/members'
      path: '/members'
      fullPath: '/admin/members'
      preLoaderRoute: typeof AdminMembersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/storage': {
      id: '/admin/storage'
      path: '/storage'
      fullPath: '/admin/storage'
      preLoaderRoute: typeof AdminStorageRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/team': {
      id: '/admin/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AdminTeamRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/webhooks': {
      id: '/admin/webhooks'
      path: '/webhooks'
      fullPath: '/admin/webhooks'
      preLoaderRoute: typeof AdminWebhooksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/auth/handoff': {
      id: '/auth/handoff'
      path: '/auth/handoff'
      fullPath: '/auth/handoff'
      preLoaderRoute: typeof AuthHandoffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/': {
      id: '/games/'
      path: '/games'
      fullPath: '/games/'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$slug': {
      id: '/games/$slug'
      path: '/games/$slug'
      fullPath: '/games/$slug'
      preLoaderRoute: typeof GamesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/games/': {
      id: '/admin/games/'
      path: '/'
      fullPath: '/admin/games/'
      preLoaderRoute: typeof AdminGamesIndexRouteImport
      parentRoute: typeof AdminGamesRoute
    }
    '/admin/games/$id/builds': {
      id: '/admin/games/$id/builds'
      path: '/$id/builds'
      fullPath: '/admin/games/$id/builds'
      preLoaderRoute: typeof AdminGamesIdBuildsRouteImport
      parentRoute: typeof AdminGamesRoute
    }
    '/admin/games/$id/edit': {
      id: '/admin/games/$id/edit'
      path: '/$id/edit'
      fullPath: '/admin/games/$id/edit'
      preLoaderRoute: typeof AdminGamesIdEditRouteImport
      parentRoute: typeof AdminGamesRoute
    }
  }
}

interface AdminGamesRouteChildren {
  AdminGamesIndexRoute: typeof AdminGamesIndexRoute
  AdminGamesIdBuildsRoute: typeof AdminGamesIdBuildsRoute
  AdminGamesIdEditRoute: typeof AdminGamesIdEditRoute
}

const AdminGamesRouteChildren: AdminGamesRouteChildren = {
  AdminGamesIndexRoute: AdminGamesIndexRoute,
  AdminGamesIdBuildsRoute: AdminGamesIdBuildsRoute,
  AdminGamesIdEditRoute: AdminGamesIdEditRoute,
}

const AdminGamesRouteWithChildren = AdminGamesRoute._addFileChildren(
  AdminGamesRouteChildren,
)

interface AdminRouteChildren {
  AdminApiKeysRoute: typeof AdminApiKeysRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminGamesRoute: typeof AdminGamesRouteWithChildren
  AdminInsightsRoute: typeof AdminInsightsRoute
  AdminMembersRoute: typeof AdminMembersRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminStorageRoute: typeof AdminStorageRoute
  AdminTeamRoute: typeof AdminTeamRoute
  AdminWebhooksRoute: typeof AdminWebhooksRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminApiKeysRoute: AdminApiKeysRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminGamesRoute: AdminGamesRouteWithChildren,
  AdminInsightsRoute: AdminInsightsRoute,
  AdminMembersRoute: AdminMembersRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminStorageRoute: AdminStorageRoute,
  AdminTeamRoute: AdminTeamRoute,
  AdminWebhooksRoute: AdminWebhooksRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  AdminRoute: AdminRouteWithChildren,
  DownloadRoute: DownloadRoute,
  DownloadsRoute: DownloadsRoute,
  HomeRoute: HomeRoute,
  JoinRoute: JoinRoute,
  LibraryRoute: LibraryRoute,
  ModdingRoute: ModdingRoute,
  NotificationsRoute: NotificationsRoute,
  PrivacyRoute: PrivacyRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  SigninRoute: SigninRoute,
  StudioRoute: StudioRoute,
  TermsRoute: TermsRoute,
  AuthHandoffRoute: AuthHandoffRoute,
  GamesSlugRoute: GamesSlugRoute,
  GamesIndexRoute: GamesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
